import { cookieController } from './cookieController.js';

(() => {
    class ModalController {
        constructor() {
            this.modal = document.querySelector('#nbps-alarm-modal');

            window.addEventListener('load', this.modalInit.bind(this));
        }

        modalInit() {            
            let modalCookie = cookieController.getCookie('nbps-alarm');
            console.log(modalCookie);
            if(modalCookie == "") {
                this.modalShow();
                let modalCloseButton = this.modal.querySelector('#modal-close');
                modalCloseButton.addEventListener('click', ()=> { this.modalClose() });
            }
            return;
        }

        modalShow = ()=> {
            this.modal.style.display = 'block';
            return;
        }

        modalClose = ()=> {
            this.modal.style.display = 'none';
            let endDate = this.convertDate(this.modal);
            let now = new Date();
            let cookieSeconds = Math.floor(Math.abs(endDate - now));
            cookieController.setCookie("nbps-alarm", "hide", cookieSeconds);
            console.log(cookieSeconds);
            return;
        }

        convertDate = (modal)=> {
            let endDate = modal.dataset.enddate;
            let dateParts = endDate.split("/");
            let dateObj = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
            return dateObj;
        }
    }
    document.addEventListener('DOMContentLoaded', () => {
        if(document.querySelector('#nbps-alarm-modal')) {
            let modalControl = new ModalController()
        }
    })
})();